var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "b-tooltip",
          rawName: "v-b-tooltip.hover",
          modifiers: { hover: true }
        }
      ],
      attrs: { id: "deliverable__type__icon", title: _vm.deliverableType }
    },
    [
      _c("div", { staticClass: "media-call-icon pointer-default" }, [
        _c("img", {
          attrs: {
            src: require("@/csmworkflow/img/" +
              _vm.deliverableTypeIcon +
              ".svg")
          }
        })
      ]),
      _vm._v(" "),
      _vm.deliverableProject &&
      _vm.deliverableProject.project_status &&
      _vm.deliverableProject.project_status.slug &&
      _vm.deliverableProject.project_status.slug == "on-hold"
        ? _c(
            "span",
            {
              staticClass: "deliverable__type__pause__icon",
              style: _vm.applyBackgroundColorIfOnHold(_vm.deliverableProject)
            },
            [_c("i", { staticClass: "fa fa-pause" })]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }